// removed by extract-text-webpack-plugin
module.exports = {"pin":"src-components-AugustaMap----styles-module---pin---8EfZ6","icon":"src-components-AugustaMap----styles-module---icon---28z9g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AugustaMap/styles.module.css
// module id = 493
// module chunks = 168707334958949